import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { TabPanel as UITabPanel } from '../../../../../../../primitives/index.js';
export const TabPanel = /*#__PURE__*/_styled(UITabPanel, process.env.NODE_ENV === "production" ? {
  target: "e1i5hiua0"
} : {
  target: "e1i5hiua0",
  label: "TabPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "1hcx8jb",
  styles: "padding:0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYlBhbmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUyQyIsImZpbGUiOiJUYWJQYW5lbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRhYlBhbmVsIGFzIFVJVGFiUGFuZWwgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi8uLi8uLi9wcmltaXRpdmVzL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBUYWJQYW5lbCA9IHN0eWxlZChVSVRhYlBhbmVsKSBgXG4gIHBhZGRpbmc6IDA7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9VGFiUGFuZWwuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});